package team.platforma.multiplatform_material_extension.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.input.pointer.PointerInputChange

@Composable
fun rememberKeyGrabber(): KeyGrabber {
    return remember { KeyGrabberImpl }
}

fun keyGrabber(): KeyGrabber {
    return KeyGrabberImpl
}

/**
 *
 * @author Evgeny Minaenkov
 * @see [rememberKeyGrabber]
 *
 */
fun Modifier.keyGrabber(keyGrabber: KeyGrabber?, keys: List<Key>): Modifier {
    return this.onPreviewKeyEvent { event ->
        if (event.type == KeyEventType.KeyDown && keys.contains(event.key)) {
            keyGrabber?.grabKey(event.key)
            true
        } else {
            false
        }
    }

}

interface KeyGrabber {
    fun grabKey(key: Key)
    fun addListener(listener: KeyGrabberListener)
    fun removeListener(listener: KeyGrabberListener)
}

interface KeyGrabberListener {
    fun onGrabKey(key: Key)
}

private object KeyGrabberImpl : KeyGrabber {
    private val listeners = mutableListOf<KeyGrabberListener>()
    override fun grabKey(key: Key) {
        listeners.forEach {
            it.onGrabKey(key)
        }
    }

    override fun addListener(listener: KeyGrabberListener) {
        listeners.add(listener)
    }

    override fun removeListener(listener: KeyGrabberListener) {
        listeners.remove(listener)
    }
}




